"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("./analytics");
var logging_1 = require("./logging");
var session_1 = require("./session");
exports.default = (function (options) {
    session_1.initialize(options);
    analytics_1.initialize(options);
    logging_1.initialize(options);
});
//# sourceMappingURL=initialize.js.map